export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_assignment_manage',
  'inbox_view',
  'search_view',
  'notifications_view',
  'engage_view',
  'vip_view',
  'issue_view',
  'team_view',
  'wlab_ai_agent_view',
  'contact_manage',
  'report_manage',
  'report_overview_view',
  'report_conversation_view',
  'report_agent_view',
  'report_case_closing_types_view',
  'report_chat_history_export_view',
  'report_label_view',
  'report_inbox_view',
  'report_team_view',
  'report_vip_view',
  'report_vip_agent_view',
  'report_issue_view',
  'report_token_usage_view',
  'report_csat_view',
  'report_sla_view',
  'report_bot_view',
  'report_telegram_bot_view',
  'line_delivery_reports_view',
  'reports_override',
  'cross_brand_report_view',
  'qa_dashboard_view',
  'qa_live_monitor_view',
  'knowledge_base_manage',
  'custom_role_manage',
  'account_manage',
  'agent_manage',
  'agent_status_manage',
  'agent_profile_manage',
  'team_management_view',
  'team_manage',
  'agent_bot_manage',
  'ailab_manage',
  'campaign_manage',
  'issue_manage',
  'sla_manage',
  'automation_manage',
  'vip_manage',
  'integration_manage',
  'label_manage',
  'inbox_manage',
  'assignment_policy_manage',
  'attendance_manage',
  'custom_attribute_manage',
  'macro_manage',
  'canned_response_manage',
  'canned_response_public_manage',
  'canned_response_private_manage',
  'flex_template_manage',
  'billing_manage',
  'audit_log_manage',
  'security_manage',
  'profile_manage',
  'line_sticker_manage',
  'telegram_audience_manage',
  'telegram_internal_view',
];

export const ROLES = ['agent', 'administrator'];
export const LEGACY_AGENT_ONLY_PERMISSIONS = {
  allOf: ['agent'],
  noneOf: ['custom_role'],
};

export const CONVERSATION_PERMISSIONS = [
  'conversation_participating_manage',
  'conversation_unassigned_manage',
  'conversation_assignment_manage',
  'conversation_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONVERSATION_ASSIGNMENT_PERMISSIONS =
  'conversation_assignment_manage';

export const INBOX_VIEW_PERMISSIONS = 'inbox_view';

export const SEARCH_PERMISSIONS = 'search_view';

export const NOTIFICATIONS_PERMISSIONS = 'notifications_view';

export const ENGAGE_VIEW_PERMISSIONS = 'engage_view';

export const VIP_VIEW_PERMISSIONS = 'vip_view';

export const ISSUE_VIEW_PERMISSIONS = 'issue_view';

export const TEAM_VIEW_PERMISSIONS = 'team_view';

export const WLAB_AI_AGENT_VIEW_PERMISSIONS = 'wlab_ai_agent_view';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';
export const REPORT_OVERVIEW_PERMISSIONS = 'report_overview_view';
export const REPORT_CONVERSATION_PERMISSIONS = 'report_conversation_view';
export const REPORT_AGENT_PERMISSIONS = 'report_agent_view';
export const REPORT_CASE_CLOSING_TYPES_PERMISSIONS =
  'report_case_closing_types_view';
export const REPORT_CHAT_HISTORY_EXPORT_PERMISSIONS =
  'report_chat_history_export_view';
export const REPORT_LABEL_PERMISSIONS = 'report_label_view';
export const REPORT_INBOX_PERMISSIONS = 'report_inbox_view';
export const REPORT_TEAM_PERMISSIONS = 'report_team_view';
export const REPORT_VIP_PERMISSIONS = 'report_vip_view';
export const REPORT_VIP_AGENT_PERMISSIONS = 'report_vip_agent_view';
export const REPORT_ISSUE_PERMISSIONS = 'report_issue_view';
export const REPORT_TOKEN_USAGE_PERMISSIONS = 'report_token_usage_view';
export const REPORT_CSAT_PERMISSIONS = 'report_csat_view';
export const REPORT_SLA_PERMISSIONS = 'report_sla_view';
export const REPORT_BOT_PERMISSIONS = 'report_bot_view';
export const REPORT_TELEGRAM_BOT_PERMISSIONS = 'report_telegram_bot_view';
export const LINE_DELIVERY_REPORTS_PERMISSIONS = 'line_delivery_reports_view';
export const CROSS_BRAND_REPORTS_PERMISSIONS = 'cross_brand_report_view';
export const QA_DASHBOARD_VIEW_PERMISSIONS = 'qa_dashboard_view';
export const QA_LIVE_MONITOR_VIEW_PERMISSIONS = 'qa_live_monitor_view';

export const REPORTS_OVERRIDE_PERMISSIONS = 'reports_override';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const CUSTOM_ROLE_PERMISSIONS = 'custom_role_manage';

export const ACCOUNT_PERMISSIONS = 'account_manage';

export const AGENT_PERMISSIONS = 'agent_manage';

export const AGENT_STATUS_PERMISSIONS = 'agent_status_manage';

export const AGENT_PROFILE_PERMISSIONS = 'agent_profile_manage';

export const TEAM_MANAGEMENT_VIEW_PERMISSIONS = 'team_management_view';

export const TEAM_PERMISSIONS = 'team_manage';

export const AGENT_BOT_PERMISSIONS = 'agent_bot_manage';

export const AILAB_PERMISSIONS = 'ailab_manage';

export const CAMPAIGN_PERMISSIONS = 'campaign_manage';

export const ISSUE_PERMISSIONS = 'issue_manage';

export const SLA_PERMISSIONS = 'sla_manage';

export const AUTOMATION_PERMISSIONS = 'automation_manage';

export const VIP_PERMISSIONS = 'vip_manage';

export const INTEGRATION_PERMISSIONS = 'integration_manage';

export const LABEL_PERMISSIONS = 'label_manage';

export const INBOX_PERMISSIONS = 'inbox_manage';

export const ASSIGNMENT_POLICY_PERMISSIONS = 'assignment_policy_manage';
export const ATTENDANCE_PERMISSIONS = 'attendance_manage';
export const CUSTOM_ATTRIBUTE_PERMISSIONS = 'custom_attribute_manage';

export const MACRO_PERMISSIONS = 'macro_manage';

export const CANNED_RESPONSE_PERMISSIONS = 'canned_response_manage';

export const CANNED_RESPONSE_PUBLIC_PERMISSIONS =
  'canned_response_public_manage';

export const CANNED_RESPONSE_PRIVATE_PERMISSIONS =
  'canned_response_private_manage';

export const FLEX_TEMPLATE_PERMISSIONS = 'flex_template_manage';

export const BILLING_PERMISSIONS = 'billing_manage';

export const AUDIT_LOG_PERMISSIONS = 'audit_log_manage';

export const SECURITY_PERMISSIONS = 'security_manage';

export const PROFILE_PERMISSIONS = 'profile_manage';

export const LINE_STICKER_PERMISSIONS = 'line_sticker_manage';
export const TELEGRAM_AUDIENCE_PERMISSIONS = 'telegram_audience_manage';
export const TELEGRAM_INTERNAL_VIEW_PERMISSIONS = 'telegram_internal_view';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};

export const CUSTOM_ROLE_PERMISSION_GROUPS = [
  {
    key: 'MY_INBOX',
    permissions: [
      INBOX_VIEW_PERMISSIONS,
      NOTIFICATIONS_PERMISSIONS,
      SEARCH_PERMISSIONS,
    ],
  },
  {
    key: 'CONVERSATION',
    permissions: [
      CONVERSATION_PARTICIPATING_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      CONVERSATION_ASSIGNMENT_PERMISSIONS,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      VIP_VIEW_PERMISSIONS,
      ISSUE_VIEW_PERMISSIONS,
      TEAM_VIEW_PERMISSIONS,
      WLAB_AI_AGENT_VIEW_PERMISSIONS,
    ],
  },
  {
    key: 'AILAB',
    permissions: [AILAB_PERMISSIONS],
  },
  {
    key: 'CONTACT',
    permissions: [CONTACT_PERMISSIONS],
  },
  {
    key: 'ENGAGE_TRAFFIC',
    permissions: [ENGAGE_VIEW_PERMISSIONS],
  },
  {
    key: 'TEAMS',
    permissions: [
      TEAM_MANAGEMENT_VIEW_PERMISSIONS,
      AGENT_STATUS_PERMISSIONS,
      AGENT_PROFILE_PERMISSIONS,
      AGENT_PERMISSIONS,
      TEAM_PERMISSIONS,
      ISSUE_PERMISSIONS,
      ATTENDANCE_PERMISSIONS,
      ASSIGNMENT_POLICY_PERMISSIONS,
    ],
  },
  {
    key: 'REPORT',
    permissions: [
      REPORTS_PERMISSIONS,
      REPORT_OVERVIEW_PERMISSIONS,
      REPORT_CONVERSATION_PERMISSIONS,
      REPORT_AGENT_PERMISSIONS,
      REPORT_CASE_CLOSING_TYPES_PERMISSIONS,
      REPORT_CHAT_HISTORY_EXPORT_PERMISSIONS,
      REPORT_LABEL_PERMISSIONS,
      REPORT_INBOX_PERMISSIONS,
      REPORT_TEAM_PERMISSIONS,
      REPORT_VIP_PERMISSIONS,
      REPORT_VIP_AGENT_PERMISSIONS,
      REPORT_ISSUE_PERMISSIONS,
      REPORT_TOKEN_USAGE_PERMISSIONS,
      REPORT_CSAT_PERMISSIONS,
      REPORT_SLA_PERMISSIONS,
      REPORT_BOT_PERMISSIONS,
      REPORT_TELEGRAM_BOT_PERMISSIONS,
      REPORTS_OVERRIDE_PERMISSIONS,
      LINE_DELIVERY_REPORTS_PERMISSIONS,
      CROSS_BRAND_REPORTS_PERMISSIONS,
    ],
  },
  {
    key: 'QA_DASHBOARD',
    permissions: [
      QA_DASHBOARD_VIEW_PERMISSIONS,
      QA_LIVE_MONITOR_VIEW_PERMISSIONS,
    ],
  },
  {
    key: 'CAMPAIGN',
    permissions: [CAMPAIGN_PERMISSIONS],
  },
  {
    key: 'SETTINGS',
    permissions: [
      ACCOUNT_PERMISSIONS,
      PROFILE_PERMISSIONS,
      SECURITY_PERMISSIONS,
      BILLING_PERMISSIONS,
      INBOX_PERMISSIONS,
      AGENT_BOT_PERMISSIONS,
      AUTOMATION_PERMISSIONS,
      INTEGRATION_PERMISSIONS,
      SLA_PERMISSIONS,
      VIP_PERMISSIONS,
      LABEL_PERMISSIONS,
      CUSTOM_ATTRIBUTE_PERMISSIONS,
      LINE_STICKER_PERMISSIONS,
      FLEX_TEMPLATE_PERMISSIONS,
      MACRO_PERMISSIONS,
      CANNED_RESPONSE_PERMISSIONS,
      CANNED_RESPONSE_PUBLIC_PERMISSIONS,
      CANNED_RESPONSE_PRIVATE_PERMISSIONS,
      TELEGRAM_AUDIENCE_PERMISSIONS,
      TELEGRAM_INTERNAL_VIEW_PERMISSIONS,
      PORTAL_PERMISSIONS,
      AUDIT_LOG_PERMISSIONS,
      CUSTOM_ROLE_PERMISSIONS,
    ],
  },
];

export const CUSTOM_ROLE_PERMISSION_GROUP_LOOKUP =
  CUSTOM_ROLE_PERMISSION_GROUPS.reduce((acc, group) => {
    group.permissions.forEach(permission => {
      acc[permission] = group.key;
    });
    return acc;
  }, {});

export const CUSTOM_ROLE_PERMISSION_GROUP_KEY_ORDER_LOOKUP =
  CUSTOM_ROLE_PERMISSION_GROUPS.reduce((acc, group, index) => {
    acc[group.key] = index;
    return acc;
  }, {});

export const CUSTOM_ROLE_PERMISSION_ORDER_LOOKUP = (() => {
  const order = {};
  let index = 0;

  CUSTOM_ROLE_PERMISSION_GROUPS.forEach(group => {
    group.permissions.forEach(permission => {
      if (!(permission in order)) {
        order[permission] = index;
        index += 1;
      }
    });
  });

  return order;
})();

export const sortCustomRoleGroupKeys = groupKeys => {
  return [...groupKeys].sort((a, b) => {
    const aOrder = CUSTOM_ROLE_PERMISSION_GROUP_KEY_ORDER_LOOKUP[a];
    const bOrder = CUSTOM_ROLE_PERMISSION_GROUP_KEY_ORDER_LOOKUP[b];

    if (aOrder === undefined && bOrder === undefined) {
      return a.localeCompare(b);
    }
    if (aOrder === undefined) {
      return 1;
    }
    if (bOrder === undefined) {
      return -1;
    }

    return aOrder - bOrder;
  });
};

export const sortCustomRolePermissions = permissions => {
  return [...permissions].sort((a, b) => {
    const aOrder = CUSTOM_ROLE_PERMISSION_ORDER_LOOKUP[a];
    const bOrder = CUSTOM_ROLE_PERMISSION_ORDER_LOOKUP[b];

    if (aOrder === undefined && bOrder === undefined) {
      return a.localeCompare(b);
    }
    if (aOrder === undefined) {
      return 1;
    }
    if (bOrder === undefined) {
      return -1;
    }
    if (aOrder === bOrder) {
      return a.localeCompare(b);
    }

    return aOrder - bOrder;
  });
};

// Conversation sidebar visibility is no longer split by these page-level filters.
// Keep them in backend model for compatibility, but hide from role editor UI.
export const CUSTOM_ROLE_HIDDEN_PERMISSIONS = [
  VIP_VIEW_PERMISSIONS,
  ISSUE_VIEW_PERMISSIONS,
  TEAM_VIEW_PERMISSIONS,
  WLAB_AI_AGENT_VIEW_PERMISSIONS,
];
